import get from 'lodash/get';
import partialRight from 'lodash/partialRight';
import some from 'lodash/some';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import LoginAccessForm from './LoginAccessForm';
import LoginFooter from './LoginFooter';
import LoginHeaderImage from './LoginHeaderImage';
import LoginLeft from './LoginLeft';
import LoginPasswordChangeForm from './LoginPasswordChangeForm';
import OfflineLoginForm from './OfflineLoginForm';
import RegistrationForm from './RegistrationForm';
import { login } from '../../../actions/AuthActions';
import * as Urls from '../../../constants/Urls';
import { getNetworkStatus } from '../../../form-designer/selectors/common.selectors';
import { shouldUsePasskeyCredentials } from '../../../utils/credential.utils';
import { getEnvVar } from '../../../utils/env';

const selectErrors = partialRight(get, 'errors');

const selectIsHomeRedirect = createSelector(selectErrors, partialRight(some, ['code', '50001']));

const Login = ({ disablePasswordChangeScreen = true, showRegistrationScreen = false }) => {
  const history = useHistory();
  const location = useLocation();
  const isHomeRedirect = useSelector(selectIsHomeRedirect);
  const isOnline = useSelector(getNetworkStatus);
  const dispatch = useDispatch();

  useEffect(() => {
    const previousRoute = get(location, 'state.from.pathname', '');

    if (isHomeRedirect && previousRoute !== Urls.HOME) {
      history.replace(Urls.HOME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const username = process.env.REACT_APP_LOCAL_USERNAME;
    const password = process.env.REACT_APP_LOCAL_PWD;
    const bypass = getEnvVar('ENABLE_LOGIN_BYPASS');
    if (window.location.hostname === 'localhost' && bypass && username && password) {
      dispatch(
        login({
          username,
          password,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login-bg" dir="ltr">
      <LoginLeft />
      <div className="login">
        <LoginHeaderImage />
        {!disablePasswordChangeScreen ? (
          <LoginPasswordChangeForm />
        ) : showRegistrationScreen ? (
          <RegistrationForm />
        ) : isOnline || !shouldUsePasskeyCredentials() ? (
          <LoginAccessForm />
        ) : (
          <OfflineLoginForm />
        )}
        <LoginFooter />
      </div>
    </div>
  );
};

export default Login;
